// WHAT ONE PARTNER ACTUALLY COLLECTED — one line per engagement, and a foot.
//
// The only drill-down this screen has left. It answers the plainest question the gap
// above it cannot: "fine, but what did I take in?" Two columns, because that is how many
// the question has — which engagement, and how much.
//
// PLAIN ROWS, NOT A TABLE. A two-column table would need two column headings, and there
// is nothing to head: the left side is a name and the right side is money, which the
// reader can see. Headings here would be furniture, and furniture is what this screen
// was being cleared of.
//
// THE FOOT IS THE SAME NUMBER AS THE STATEMENT'S FIRST LINE, and that is why it is
// printed. The rows come from the very query the balance's cash side is built from
// (calculations/collectedByPartner), so they cannot disagree with `collected` above —
// this shows that they don't, rather than asking to be trusted.
//
// Everything here is display: the client re-adds nothing. The foot renders the server's
// `total`, never a sum of the rows.
import he from '../../i18n/he';
import Money from '../../components/Money';

const t = he.settlements.collectedList;
const u = he.settlements.unit;

const Row = ({ children, className = '' }) => (
  <div className={`settle-collected-row ${className}`.trim()}>{children}</div>
);

export default function CollectedList({ partner }) {
  const list = partner.collectedFrom || { rows: [], total: 0 };

  return (
    <div className="settle-collected">
      <h3 className="settle-collected-name">{partner.name}</h3>
      {list.rows.length === 0 ? (
        <p className="muted small-note">{t.empty}</p>
      ) : (
        <>
          {list.rows.map((r) => (
            <Row key={r.unit}>
              <span>
                {/* Same badge treatment a unit gets everywhere else it is named — the
                    monthly view below, the dashboard's tile — from one shared block. */}
                <span className={`badge ${r.kind === 'retainer' ? 'blue' : 'gray'}`}>
                  {r.kind === 'retainer' ? u.retainer : u.job}
                </span>{' '}
                {r.title || u.unnamed}
                {r.clientName && <span className="muted"> · {r.clientName}</span>}
              </span>
              <Money value={r.collected} />
            </Row>
          ))}
          <Row className="foot">
            <strong>{t.total}</strong>
            <strong><Money value={list.total} /></strong>
          </Row>
        </>
      )}
    </div>
  );
}
